module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Dial-numbers-c0e7fb29ca91804323b859e3acd89914.svg";